module.exports = __webpack_public_path__ + "static/img/savedbear.88db211.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/downgrade/images/savedbear.png
// module id = CMGK
// module chunks = 12